import React from 'react';
import '../styles/theme.css';
import '../styles/Loans.css';
import MontreauxSiteHeader from '../components/MontreauxSiteHeader';
import Footer from '../components/Footer';
import LoansContent from '../components/LoansContent';
/* IMPORTS */

function LoansPage() {
  return (
    <div className="lo-root">
      <div id="montreauxsiteheader" className="lo-slot-montreauxsiteheader">
        <MontreauxSiteHeader activePage={"Loans"} />
      </div>
      <div id="loanscontent" className="lo-slot-loanscontent">
        <LoansContent />
      </div>
      <div id="footer" className="lo-slot-footer">
        <Footer />
      </div>
    </div>
  );
}

export default LoansPage;
